import { format } from "date-fns";

export function getWorkSheets(data) {
    const groupedDates = {};

    data.forEach(event => {
        const date = new Date(event.dataAcontecimento);
        const yearMonth = `${format(date, 'MMMM')}-${date.getFullYear()}`;

        if (!groupedDates[yearMonth]) {
            groupedDates[yearMonth] = [];
        }

        groupedDates[yearMonth].push(event);
    });

    return groupedDates;
}

export function getWorkSheetsByTerminalName(data) {
    const locationAggroup = {};

    data.forEach(event => {

        if (!locationAggroup[event.local]) {
            locationAggroup[event.local] = [];
        }

        locationAggroup[event.local].push({ ...event, data: format(new Date(event.dataAcontecimento), 'dd/MM/yyyy'), n: locationAggroup[event.local].length + 1 });
    });

    Object?.keys?.(locationAggroup).forEach(location => {
        locationAggroup[location] = getWorkSheets(locationAggroup[location])
    })

    return locationAggroup;
}


